// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Ensure the body and HTML fill the viewport */
body, html {
  min-height: 100%; /* Ensures the body and HTML fill the viewport */
  margin: 0;
  display: flex;
  flex-direction: column; /* Allows vertical alignment of elements */
  background-color: #100505;
}

/* Home page container */
.Home {
  display: flex;
  flex-direction: column;
  min-height: 100vh; /* Ensures the container fills the viewport height */
  background-color: #100505; /* Fallback color for sides */
  color: black; /* Default text color */
  padding-left: 20px; /* Adds padding to the left */
  box-sizing: border-box; /* Ensures padding doesn't cause overflow */
  margin-top: 5%;
}

/* Logo Style */
.logo {
  width: 12%; /* Adjust size as needed */
  height: auto;
  border-radius: 50%; /* Circular logo */
  margin: auto; /* Center the logo horizontally and vertically */
  display: block;
  position: relative; /* Ensures compatibility with flexbox */
}

/* Header */
.header {
  display: flex;
  justify-content: center; /* Center horizontally */
  align-items: center; /* Center vertically */
  flex-direction: column; /* Stack elements vertically */
  background-color: #100505; /* Optional */
  padding: 0;
  margin: 0;
}

/* FAQ Section */
.faq-section {
  display: flex; /* Aligns the FAQ section horizontally */
  justify-content: flex-start;
  align-items: flex-start;
  width: 100%;
  max-width: 100%; /* Ensures it doesn't exceed 100% width */
  padding: 20px;
  color: white;
  box-sizing: border-box; /* Ensures padding doesn't cause overflow */
  margin-top: 5%; /* Moves the FAQ section up by 5% */
}

.faq-container {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap; /* Allow wrapping if content overflows horizontally */
  width: 100%;
}

.faq-topics {
  flex: 1 1;
  max-width: 300px; /* Restrict the width of the topics container */
  padding: 10px;
  background: rgba(0, 0, 0, 0.3);
  border-radius: 10px;
  overflow-y: auto;
  box-sizing: border-box; /* Prevent overflow issues */
}

.faq-title {
  font-size: 1.2rem;
  font-weight: bold;
  cursor: pointer;
  background: rgba(255, 255, 255, 0.1);
  padding: 10px;
  border-radius: 5px;
  margin-bottom: 10px;
  transition: background 0.3s ease, transform 0.3s ease;
}

.faq-title:hover,
.faq-title.active {
  background: rgba(255, 255, 255, 0.2);
  transform: translateY(-2px);
}

/* Content display area */
.faq-display {
  flex: 2 1;
  padding: 20px;
  background: rgba(0, 0, 0, 0.3);
  border-radius: 10px;
  margin-left: 20px;
  max-width: 100%; /* Ensures it doesn't exceed the container's width */
  box-sizing: border-box; /* Prevents overflow */
}

.faq-content {
  font-size: 1rem;
  line-height: 1.5;
}

.faq-content ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.faq-content li {
  margin-bottom: 10px;
}

/* Link Styles within FAQ content */
.faq-content a {
  color: white; /* Make links white */
  text-decoration: none; /* Remove underline */
}

.faq-content a:hover {
  text-decoration: underline; /* Underline on hover for better UX */
}

/* Button Styles */
.btn-primary {
  display: inline-block;
  background: rgba(0, 0, 0, 0.6);
  color: white;
  text-decoration: none;
  font-size: 16px;
  font-weight: bold;
  padding: 10px 20px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  transition: background-color 0.3s ease, transform 0.2s ease;
  margin-top: 3%;
}

.btn-primary:hover {
  background: rgba(0, 0, 0, 0.6);
  transform: translateY(-2px);
}

.btn-primary:active {
  background: rgba(0, 0, 0, 0.6);
  transform: translateY(1px);
}

.btn-book {
  display: inline-block;
  margin-top: 10px;
  padding: 10px 20px;
  background: rgba(0, 0, 0, 0.6);
  color: white;
  text-decoration: none;
  border-radius: 5px;
  transition: background 0.3s ease, transform 0.3s ease;
}

.btn-book:hover {
  background: rgba(255, 255, 255, 0.2);
  transform: translateY(-2px);
}

/* Footer */
.footer {
  background-color: #100505;
  color: white;
  text-align: center;
  padding: 10px 0;
  font-size: 14px;
  width: 100%;
  position: fixed;
  bottom: 0;
  left: 0;
}

.form-container {
  max-width: 800px;
  margin: 0 auto;
  padding: 20px;
  text-align: center;
  background-color: black;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.customer-support-message {
  color: white;
  font-weight: bold;
  font-size: 1.2rem;
  text-align: center;
  white-space: nowrap; /* Prevents the text from breaking into multiple lines */
}


.home-button-container {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%; /* Take up full width */
  margin-bottom: 3px; /* Space between home button and form */
}

.home-button {
  background-color: #00BFA6;
  color: white;
  padding: 15px 30px;
  text-decoration: none;
  border-radius: 50px;
  font-size: 1.2rem;
  font-weight: bold;
  transition: background-color 0.3s ease, transform 0.3s ease, box-shadow 0.3s ease;
  box-shadow: 0 10px 20px rgba(148, 128, 255, 0.5);
}

.home-button:hover {
  background-color: #009C89;
  transform: translateY(-5px);
  box-shadow: 0 15px 40px rgba(148, 128, 255, 0.6);
}

form {
  display: flex;
  flex-direction: column;
  gap: 40px;
  width: 100%;
  max-width: 700px;
  background-color: #F4F7FA;
  padding: 30px;
  border-radius: 10px;
  box-shadow: 0 5px 20px rgba(148, 128, 255, 0.5);
}

.submission-confirmation {
  display: flex;
  flex-direction: column;
  justify-content: center; /* Center align the content */
  align-items: center;
  padding: 20px;
  text-align: center;
  color: white !important;
  background-color: rgba(0, 0, 0, 0.8);
  margin-top: 20px;
}

.submission-confirmation h3 {
  font-size: 2rem;
  margin-bottom: 15px;
}

.submission-confirmation p {
  font-size: 1rem;
  margin-top: 10px;
}

fieldset legend {
  font-size: 1.2rem;
  color: #333333;
  padding: 0 10px;
}

.communications,
.project-links {
  flex: 1 1;
}

label {
  display: block;
  margin-bottom: 10px;
}

input[type="text"] {
  font-size: 1rem;
  padding: 5px;
  border: 1px solid #E0E0E0;
  border-radius: 5px;
  width: 90%;
}

button[type="submit"] {
  align-self: center;
  background-color: #7E57C2;
  color: white;
  padding: 15px 30px;
  border-radius: 50px;
  font-size: 1.1rem;
  font-weight: bold;
  box-shadow: 0 10px 20px rgba(126, 87, 194, 0.5);
  cursor: pointer;
  border: none;
  transition: all 0.3s ease;
}

button[type="submit"]:hover {
  background-color: #6A48AF;
  box-shadow: 0 15px 40px rgba(126, 87, 194, 0.6);
  transform: translateY(-3px);
}

.captcha-container {
  display: flex;
  justify-content: center;
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA,+CAA+C;AAC/C;EACE,gBAAgB,EAAE,gDAAgD;EAClE,SAAS;EACT,aAAa;EACb,sBAAsB,EAAE,0CAA0C;EAClE,yBAAyB;AAC3B;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,sBAAsB;EACtB,iBAAiB,EAAE,oDAAoD;EACvE,yBAAyB,EAAE,6BAA6B;EACxD,YAAY,EAAE,uBAAuB;EACrC,kBAAkB,EAAE,6BAA6B;EACjD,sBAAsB,EAAE,2CAA2C;EACnE,cAAc;AAChB;;AAEA,eAAe;AACf;EACE,UAAU,EAAE,0BAA0B;EACtC,YAAY;EACZ,kBAAkB,EAAE,kBAAkB;EACtC,YAAY,EAAE,gDAAgD;EAC9D,cAAc;EACd,kBAAkB,EAAE,uCAAuC;AAC7D;;AAEA,WAAW;AACX;EACE,aAAa;EACb,uBAAuB,EAAE,wBAAwB;EACjD,mBAAmB,EAAE,sBAAsB;EAC3C,sBAAsB,EAAE,8BAA8B;EACtD,yBAAyB,EAAE,aAAa;EACxC,UAAU;EACV,SAAS;AACX;;AAEA,gBAAgB;AAChB;EACE,aAAa,EAAE,wCAAwC;EACvD,2BAA2B;EAC3B,uBAAuB;EACvB,WAAW;EACX,eAAe,EAAE,yCAAyC;EAC1D,aAAa;EACb,YAAY;EACZ,sBAAsB,EAAE,2CAA2C;EACnE,cAAc,EAAE,mCAAmC;AACrD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe,EAAE,qDAAqD;EACtE,WAAW;AACb;;AAEA;EACE,SAAO;EACP,gBAAgB,EAAE,+CAA+C;EACjE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;EAChB,sBAAsB,EAAE,4BAA4B;AACtD;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,eAAe;EACf,oCAAoC;EACpC,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,qDAAqD;AACvD;;AAEA;;EAEE,oCAAoC;EACpC,2BAA2B;AAC7B;;AAEA,yBAAyB;AACzB;EACE,SAAO;EACP,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,iBAAiB;EACjB,eAAe,EAAE,oDAAoD;EACrE,sBAAsB,EAAE,sBAAsB;AAChD;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,mBAAmB;AACrB;;AAEA,mCAAmC;AACnC;EACE,YAAY,EAAE,qBAAqB;EACnC,qBAAqB,EAAE,qBAAqB;AAC9C;;AAEA;EACE,0BAA0B,EAAE,qCAAqC;AACnE;;AAEA,kBAAkB;AAClB;EACE,qBAAqB;EACrB,8BAA8B;EAC9B,YAAY;EACZ,qBAAqB;EACrB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,2DAA2D;EAC3D,cAAc;AAChB;;AAEA;EACE,8BAA8B;EAC9B,2BAA2B;AAC7B;;AAEA;EACE,8BAA8B;EAC9B,0BAA0B;AAC5B;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;EAClB,8BAA8B;EAC9B,YAAY;EACZ,qBAAqB;EACrB,kBAAkB;EAClB,qDAAqD;AACvD;;AAEA;EACE,oCAAoC;EACpC,2BAA2B;AAC7B;;AAEA,WAAW;AACX;EACE,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,WAAW;EACX,eAAe;EACf,SAAS;EACT,OAAO;AACT;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB,EAAE,wDAAwD;AAC/E;;;AAGA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW,EAAE,uBAAuB;EACpC,kBAAkB,EAAE,uCAAuC;AAC7D;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,qBAAqB;EACrB,mBAAmB;EACnB,iBAAiB;EACjB,iBAAiB;EACjB,iFAAiF;EACjF,gDAAgD;AAClD;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,gDAAgD;AAClD;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,+CAA+C;AACjD;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB,EAAE,6BAA6B;EACtD,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,uBAAuB;EACvB,oCAAoC;EACpC,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA;;EAEE,SAAO;AACT;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,iBAAiB;EACjB,+CAA+C;EAC/C,eAAe;EACf,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,+CAA+C;EAC/C,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,uBAAuB;AACzB","sourcesContent":["/* Ensure the body and HTML fill the viewport */\nbody, html {\n  min-height: 100%; /* Ensures the body and HTML fill the viewport */\n  margin: 0;\n  display: flex;\n  flex-direction: column; /* Allows vertical alignment of elements */\n  background-color: #100505;\n}\n\n/* Home page container */\n.Home {\n  display: flex;\n  flex-direction: column;\n  min-height: 100vh; /* Ensures the container fills the viewport height */\n  background-color: #100505; /* Fallback color for sides */\n  color: black; /* Default text color */\n  padding-left: 20px; /* Adds padding to the left */\n  box-sizing: border-box; /* Ensures padding doesn't cause overflow */\n  margin-top: 5%;\n}\n\n/* Logo Style */\n.logo {\n  width: 12%; /* Adjust size as needed */\n  height: auto;\n  border-radius: 50%; /* Circular logo */\n  margin: auto; /* Center the logo horizontally and vertically */\n  display: block;\n  position: relative; /* Ensures compatibility with flexbox */\n}\n\n/* Header */\n.header {\n  display: flex;\n  justify-content: center; /* Center horizontally */\n  align-items: center; /* Center vertically */\n  flex-direction: column; /* Stack elements vertically */\n  background-color: #100505; /* Optional */\n  padding: 0;\n  margin: 0;\n}\n\n/* FAQ Section */\n.faq-section {\n  display: flex; /* Aligns the FAQ section horizontally */\n  justify-content: flex-start;\n  align-items: flex-start;\n  width: 100%;\n  max-width: 100%; /* Ensures it doesn't exceed 100% width */\n  padding: 20px;\n  color: white;\n  box-sizing: border-box; /* Ensures padding doesn't cause overflow */\n  margin-top: 5%; /* Moves the FAQ section up by 5% */\n}\n\n.faq-container {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap; /* Allow wrapping if content overflows horizontally */\n  width: 100%;\n}\n\n.faq-topics {\n  flex: 1;\n  max-width: 300px; /* Restrict the width of the topics container */\n  padding: 10px;\n  background: rgba(0, 0, 0, 0.3);\n  border-radius: 10px;\n  overflow-y: auto;\n  box-sizing: border-box; /* Prevent overflow issues */\n}\n\n.faq-title {\n  font-size: 1.2rem;\n  font-weight: bold;\n  cursor: pointer;\n  background: rgba(255, 255, 255, 0.1);\n  padding: 10px;\n  border-radius: 5px;\n  margin-bottom: 10px;\n  transition: background 0.3s ease, transform 0.3s ease;\n}\n\n.faq-title:hover,\n.faq-title.active {\n  background: rgba(255, 255, 255, 0.2);\n  transform: translateY(-2px);\n}\n\n/* Content display area */\n.faq-display {\n  flex: 2;\n  padding: 20px;\n  background: rgba(0, 0, 0, 0.3);\n  border-radius: 10px;\n  margin-left: 20px;\n  max-width: 100%; /* Ensures it doesn't exceed the container's width */\n  box-sizing: border-box; /* Prevents overflow */\n}\n\n.faq-content {\n  font-size: 1rem;\n  line-height: 1.5;\n}\n\n.faq-content ul {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n}\n\n.faq-content li {\n  margin-bottom: 10px;\n}\n\n/* Link Styles within FAQ content */\n.faq-content a {\n  color: white; /* Make links white */\n  text-decoration: none; /* Remove underline */\n}\n\n.faq-content a:hover {\n  text-decoration: underline; /* Underline on hover for better UX */\n}\n\n/* Button Styles */\n.btn-primary {\n  display: inline-block;\n  background: rgba(0, 0, 0, 0.6);\n  color: white;\n  text-decoration: none;\n  font-size: 16px;\n  font-weight: bold;\n  padding: 10px 20px;\n  border: none;\n  border-radius: 5px;\n  cursor: pointer;\n  transition: background-color 0.3s ease, transform 0.2s ease;\n  margin-top: 3%;\n}\n\n.btn-primary:hover {\n  background: rgba(0, 0, 0, 0.6);\n  transform: translateY(-2px);\n}\n\n.btn-primary:active {\n  background: rgba(0, 0, 0, 0.6);\n  transform: translateY(1px);\n}\n\n.btn-book {\n  display: inline-block;\n  margin-top: 10px;\n  padding: 10px 20px;\n  background: rgba(0, 0, 0, 0.6);\n  color: white;\n  text-decoration: none;\n  border-radius: 5px;\n  transition: background 0.3s ease, transform 0.3s ease;\n}\n\n.btn-book:hover {\n  background: rgba(255, 255, 255, 0.2);\n  transform: translateY(-2px);\n}\n\n/* Footer */\n.footer {\n  background-color: #100505;\n  color: white;\n  text-align: center;\n  padding: 10px 0;\n  font-size: 14px;\n  width: 100%;\n  position: fixed;\n  bottom: 0;\n  left: 0;\n}\n\n.form-container {\n  max-width: 800px;\n  margin: 0 auto;\n  padding: 20px;\n  text-align: center;\n  background-color: black;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n}\n\n.customer-support-message {\n  color: white;\n  font-weight: bold;\n  font-size: 1.2rem;\n  text-align: center;\n  white-space: nowrap; /* Prevents the text from breaking into multiple lines */\n}\n\n\n.home-button-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 100%; /* Take up full width */\n  margin-bottom: 3px; /* Space between home button and form */\n}\n\n.home-button {\n  background-color: #00BFA6;\n  color: white;\n  padding: 15px 30px;\n  text-decoration: none;\n  border-radius: 50px;\n  font-size: 1.2rem;\n  font-weight: bold;\n  transition: background-color 0.3s ease, transform 0.3s ease, box-shadow 0.3s ease;\n  box-shadow: 0 10px 20px rgba(148, 128, 255, 0.5);\n}\n\n.home-button:hover {\n  background-color: #009C89;\n  transform: translateY(-5px);\n  box-shadow: 0 15px 40px rgba(148, 128, 255, 0.6);\n}\n\nform {\n  display: flex;\n  flex-direction: column;\n  gap: 40px;\n  width: 100%;\n  max-width: 700px;\n  background-color: #F4F7FA;\n  padding: 30px;\n  border-radius: 10px;\n  box-shadow: 0 5px 20px rgba(148, 128, 255, 0.5);\n}\n\n.submission-confirmation {\n  display: flex;\n  flex-direction: column;\n  justify-content: center; /* Center align the content */\n  align-items: center;\n  padding: 20px;\n  text-align: center;\n  color: white !important;\n  background-color: rgba(0, 0, 0, 0.8);\n  margin-top: 20px;\n}\n\n.submission-confirmation h3 {\n  font-size: 2rem;\n  margin-bottom: 15px;\n}\n\n.submission-confirmation p {\n  font-size: 1rem;\n  margin-top: 10px;\n}\n\nfieldset legend {\n  font-size: 1.2rem;\n  color: #333333;\n  padding: 0 10px;\n}\n\n.communications,\n.project-links {\n  flex: 1;\n}\n\nlabel {\n  display: block;\n  margin-bottom: 10px;\n}\n\ninput[type=\"text\"] {\n  font-size: 1rem;\n  padding: 5px;\n  border: 1px solid #E0E0E0;\n  border-radius: 5px;\n  width: 90%;\n}\n\nbutton[type=\"submit\"] {\n  align-self: center;\n  background-color: #7E57C2;\n  color: white;\n  padding: 15px 30px;\n  border-radius: 50px;\n  font-size: 1.1rem;\n  font-weight: bold;\n  box-shadow: 0 10px 20px rgba(126, 87, 194, 0.5);\n  cursor: pointer;\n  border: none;\n  transition: all 0.3s ease;\n}\n\nbutton[type=\"submit\"]:hover {\n  background-color: #6A48AF;\n  box-shadow: 0 15px 40px rgba(126, 87, 194, 0.6);\n  transform: translateY(-3px);\n}\n\n.captcha-container {\n  display: flex;\n  justify-content: center;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
